import { Component, OnInit } from '@angular/core';
import { Alert } from 'src/app/interfaces/alert';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { User, UserAddressType, UserAddress } from 'src/app/interfaces/user';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.scss']
})
export class AddAddressComponent implements OnInit {
  loading = false;
  alert: Alert = null;
  errorStrings = ErrorStrings;
  user: User;
  address: UserAddress;
  userAddressType = UserAddressType;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private userService: UserService) {
    this.user = this.route.snapshot.data.user as User;
  }

  private doesMainAddressExists(): boolean {
    let exists = false;
    this.user.addresses.forEach(address => {
      if (address.addressType === UserAddressType.Main) { exists = true; }
    });
    return exists;
  }

  closeAlert() {
    this.alert = null;
  }

  onSave() {
    this.closeAlert();
    this.loading = true;
    this.userService.saveAddress(this.address)
      .subscribe(
        () => {
          this.router.navigate(['/account']);
        },
        errorMessage => {
          this.alert = {
            type: 'danger',
            message: errorMessage
          };
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  ngOnInit(): void {
    this.address = {
      line1: null,
      line2: null,
      town: null,
      county: null,
      postcode: null,
      addressType: this.doesMainAddressExists() ? null : UserAddressType.Main,
      temporary: null,
      temporaryContactName: null,
      temporaryPhoneNumber: null,
    };
  }

}

